<dw-ui-dialog-box
  [title]="'::Import' | abpLocalization"
  (saveFn)="importQuote()"
  [saveDisabled]="quoteNumber == null"
>
  <div>
    <div class="row">
      <div class="col-12">
        <label class="form-label text-primary" for="quoteNumber" dwInputRequired>{{
          'Doc::CustomerQuote:Number' | abpLocalization
        }}</label>
        <input type="number" id="quoteNumber" class="form-control" [(ngModel)]="quoteNumber" />
      </div>
    </div>
  </div>
</dw-ui-dialog-box>
